module.exports = __webpack_public_path__ + "static/media/ACaslonPro-Bold.ad77152f.otf";